import { Injectable, OnDestroy } from '@angular/core';

import { SnLayoutNavbarContainer } from '../containers';
import { SnLayoutAppbarReference } from '../references';

@Injectable()
export class SnLayoutStorageService implements OnDestroy {
  private _appbarRef: SnLayoutAppbarReference;
  private _navbarRef: SnLayoutNavbarContainer;

  constructor() {}

  get appbarRef(): SnLayoutAppbarReference {
    return this._appbarRef;
  }
  get navbarRef(): SnLayoutNavbarContainer {
    return this._navbarRef;
  }

  public ngOnDestroy(): void {}

  public checkInAppbar(component: SnLayoutAppbarReference): void {
    if (this._appbarRef) {
      throw new Error('Layout App Bar already exist');
    }

    this._appbarRef = component;
  }

  public checkOfAppbar(): void {
    if (this._appbarRef) {
      this._appbarRef = null;
    }
  }

  public checkInNavbar(component: SnLayoutNavbarContainer): void {
    if (this._navbarRef) {
      throw new Error('Layout Nav Bar already exist');
    }

    this._navbarRef = component;
  }

  public checkOfNavbar(): void {
    if (this._navbarRef) {
      this._navbarRef = null;
    }
  }
}
